export enum HomeViewType {
  Default = 'default',
  Wechat = 'wechat',
  Discord = 'discord',
}
